var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"74366c45e38a65fe52c17760b9c043f08b5e9426"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["seedlang@seedlang"]={id:"74366c45e38a65fe52c17760b9c043f08b5e9426"};
      